import React from 'react';
import { Collapse, Spin } from 'antd';
import { CollapseDown, CollapseUp } from '../../../assets/icons';
import './Helpcenter.scss';
import { useFAQ } from '../../../Hooks/useFAQs';
import { createMarkup } from '../../../utils/createMarkup';

const Settings = () => {
  const { loading, faqList } = useFAQ(); 
  const { Panel } = Collapse;
  return (
    <div className='help-center'>
      <h4 className='help-center__title'>Support</h4>
      <div className='help-center__section'>
        <div className='help-center__section__data data'>
          <div className='data__field'>
            <p className='data__field__name'>Email Realbricks</p>
            <a href='mailto:support@realbricks.com' className='help-center__section__link'>
              support@realbricks.com
            </a>
          </div>
        </div>
      </div>
      <h4 className='help-center__title'>Frequently Asked Questions</h4>
      <Spin spinning={loading}>
        {faqList?.length ? (
          <Collapse
            accordion
            defaultActiveKey={faqList?.length > 0 ? [faqList?.[0]?.id] : []}
            expandIconPosition='end'
            expandIcon={({ isActive }) => (isActive ? <CollapseDown width='15' /> : <CollapseUp width='15' />)}
          >
            {faqList?.map((faq) => (
              <Panel header={faq?.question} key={faq?.id}>
                <div dangerouslySetInnerHTML={createMarkup(faq?.content)}></div>
              </Panel>
            ))}
          </Collapse>
        ) : (
          <>{!loading && <div>No Data Available</div>}</>
        )}
      </Spin>
    </div>
  );
};

export default Settings;
